module.exports = __webpack_public_path__ + "static/media/user-tick.fdf74848.svg";